import { UseQueryOptions } from '@tanstack/react-query';

import { agentConfigGetDeviceControlPointIdMap } from '@repo/sdk/funcs/agentConfigGetDeviceControlPointIdMap';
import { SDKError } from '@repo/sdk/models/errors';
import { GetDeviceControlPointIdMapRequest } from '@repo/sdk/models/operations';

import { GaiaClientFunction } from '@/client/types';
import { GaiaQueryWithAgentId } from '@/queries/types';

interface GetDeviceControlPointIdMapQueryProps extends GaiaQueryWithAgentId {
  client: GaiaClientFunction;
}

export const getDeviceControlPointIdMapQuery = ({
  agentId,
  client,
}: GetDeviceControlPointIdMapQueryProps): UseQueryOptions<
  { [k: string]: Array<string> },
  SDKError,
  { [k: string]: Array<string> } | undefined
> => ({
  enabled: !!agentId,
  queryKey: [agentId, 'getDeviceControlPointIdMap'],
  queryFn: () =>
    client<GetDeviceControlPointIdMapRequest, { [k: string]: Array<string> }>({
      gaiaFunc: agentConfigGetDeviceControlPointIdMap,
      request: { agentId: agentId! },
    }),
  staleTime: 5 * 60 * 1000,
});
